import React, { useMemo, useState } from 'react'
import { Document } from 'react-pdf'
import { Checkbox } from '@tecuity/granite-ui/Checkbox'
import { ContextButton } from '@tecuity/granite-ui/ContextButton'
import CrossHeavy from '@tecuity/sos-icons/react/cross-heavy'

const ReportInfo = (props) => {
  const {
    reportInfo,
    bytes = [],
    onSelectFile,
    onSelectPage,
    isActive,
    activePageIndex = 0,
    pageChanged,
    pages = [],
    closeFile,
  } = props
  const { filename = '', pdfType } = reportInfo
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)

  const selectReportCheckbox = (checked) => {
    pageChanged(
      reportInfo,
      pages.map((page) => {
        return { ...page, isChecked: checked }
      })
    )
  }

  const getPages = ({ numPages }) => {
    const pagesList = []
    for (let i = 0; i < numPages; i++) {
      pagesList.push({ isChecked: false, index: i })
    }
    pageChanged(reportInfo, pagesList)
  }

  const isChecked = useMemo(() => {
    return !!pages.find((page) => page.isChecked)
  }, [pages])

  return (
    <div className="report-file">
      <Document
        className="no-show"
        file={bytes}
        onLoadSuccess={getPages}
        loading={null}
        noData=""
      />
      <div className="report-file-header" onClick={onSelectFile}>
        <div className="report-file-header-is-selected">
          <Checkbox
            className="report-file-header-checkbox"
            ariaLabel={`is ${filename} selected`}
            checked={isChecked}
            onChange={(e) => selectReportCheckbox(e)}
          />
        </div>
        <span className="report-file-header-title">{filename}</span>
        {console.log()}
        <button
          onClick={() => {
            setShowDeleteConfirm((show) => !show)
          }}
          title={`Close ${filename} Report`}
        >
          <CrossHeavy />
        </button>
      </div>
      {showDeleteConfirm && (
        <div className="report-delete-confirm">
          <span>Are you sure you want to close this file?</span>
          <div className="report-delete-confirm-actions">
            <ContextButton
              variant={'success'}
              onClick={() => {
                setShowDeleteConfirm(false)
                closeFile()
              }}
            >
              Yes
            </ContextButton>
            <ContextButton
              variant={'danger'}
              onClick={() => {
                setShowDeleteConfirm(false)
              }}
            >
              No
            </ContextButton>
          </div>
        </div>
      )}
      <ul className="report-file-pages">
        {pages.map((page, i) => {
          return (
            <li key={filename + pdfType + (i + 1)}>
              <button
                className="report-file-page"
                data-active={isActive && activePageIndex === i}
                onClick={() => onSelectPage(i)}
              >
                {`Page ${i + 1}`}
              </button>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default ReportInfo
